
import Vue from 'vue'
import { GetAllMyArqanaHorseRegistrationDto, FindByIdMyArqanaHorseRegistrationDto, myRegistrationApi } from '@/api/auth/myHorseRegistration'
import { MandatTracking, MinimalTechnicalSaleWithSellerLetterDto, saleApi, SaleWithRegistrationsDto } from '@/api/sales'
import { getHorseTypeLabel } from '@/utils/horseType'
import { getGenderLabel } from '@/utils/genders'
import downloadFile from '@/utils/downloadFile'
import { documentsRule } from '@/views/registration/documents/rules'
import { Page } from '@/types'
import { formatISO } from 'date-fns'
import add from 'date-fns/esm/add'
import parseISO from 'date-fns/fp/parseISO/index'
import snackbarStore from '@/store/snackbarStore'
import { formatBetween } from '@/utils/dates'
import { handleAxiosException } from '@/api'

export default Vue.extend({
  name: 'RegistrationSummary',
  data: () => ({
    loading: false,
    queryUrl: false,
    salesToView: { content: [], totalElements: 0, totalPages: 0, page: 0, size: 0 } as Page<SaleWithRegistrationsDto & {expanded: boolean, expandedRegistrations: Page<FindByIdMyArqanaHorseRegistrationDto>}>,
    vetCertificateDialog: false,
    vetCertificateSale: undefined as SaleWithRegistrationsDto | undefined,
    vetCertificateFile: undefined as File | undefined,
    vetCertificateLoading: false,
    defaultVetCertificateLink: 'TODO: mettre le lien du document par défaut',
    generatingSummarySale: undefined as SaleWithRegistrationsDto | undefined,
    openedMandatSale: 0,
    selectedAction: false,
  }),
  methods: {
    formatBetween,
    getHorseTypeLabel,
    getGenderLabel,
    downloadFile,
    async loadData() {
      this.loading = true
      try {
        const data = await saleApi.getAllTechnicalSalesForRegistrations({ page: 0, size: 999, sort: ['startDate,ASC'] })
        this.salesToView = { ...data, content: data.content.map(e => ({ ...e, expanded: false, expandedRegistrations: {} as Page<FindByIdMyArqanaHorseRegistrationDto> })) }
        this.salesToView.content.forEach(e => {
          this.toggleRegistrationDetailSection(e)
        })
      } catch (err) {
        snackbarStore.setSnackbar({ text: this.$t('error.loading') as string, color: 'error' })
      }
      this.loading = false
    },
    async toggleRegistrationDetailSection(v: SaleWithRegistrationsDto & {expanded: boolean, expandedRegistrations: Page<FindByIdMyArqanaHorseRegistrationDto>}) {
      if (!v.expanded && !v.expandedRegistrations.content) {
        await myRegistrationApi.getAllWithDocuments({ saleId: v.sale.id, states: ['WAITING', 'NOT_COMPLETED'] }, { page: 0, size: 999 }).then(data => {
          // eslint-disable-next-line no-param-reassign
          v.expandedRegistrations = data
        }).catch(() => {
          snackbarStore.setSnackbar({ text: this.$t('error.loading') as string, color: 'error' })
        })
      }
      // eslint-disable-next-line no-param-reassign
      v.expanded = !v.expanded
    },
    toggleMandatSign(sale: MinimalTechnicalSaleWithSellerLetterDto) {
      if (this.openedMandatSale !== sale.id) {
        this.openedMandatSale = sale.id
      } else {
        this.openedMandatSale = 0
      }
    },
    getOptionalDocuments(r: FindByIdMyArqanaHorseRegistrationDto) {
      const rules = documentsRule[r.type]
      if (rules) {
        const entries = Object.values(rules)
        return Object.keys(rules)
          .map((key, i) => ({ type: key, rule: entries[i] }))
          .filter(e => (e.rule === 'OPTIONAL' || r.gender === 'FEMELLE' && e.rule === 'OPTIONAL_IF_FEMALE' || r.gender === 'MALE' && e.rule === 'OPTIONAL_IF_MALE' || ((r.type === 'STALLION' || r.type === 'STALLION_PART') && e.rule === 'OPTIONAL_IF_TROT'))
              && !((e.type === 'CONTRAT_FG_BUYER' || e.type === 'CONTRAT_FG_SELLER') && (r.associationContract || r.rentalContract)))
          .map(e => e.type)
      }
      return []
    },
    getMandatoryDocuments(r: FindByIdMyArqanaHorseRegistrationDto) {
      const rules = documentsRule[r.type]
      if (rules) {
        const entries = Object.values(rules)
        return Object.keys(rules)
          .map((key, i) => ({ type: key, rule: entries[i] }))
          .filter(e => e.rule === 'COMPULSORY' || e.rule === 'COMPULSORY_IF_COVERED' && (r.protrusionFormula === 'DEFAULT' || r.protrusionFormula === 'FIRST')
              || (e.type === 'CONTRAT_FG_BUYER' || e.type === 'CONTRAT_FG_SELLER') && (r.associationContract || r.rentalContract))
          .map(e => e.type)
      }
      return []
    },
    getDocumentStatus(r: FindByIdMyArqanaHorseRegistrationDto, type: string) {
      return r.documents.find(e => e.type === type)?.status
    },
    sortRegistrations(registrations: FindByIdMyArqanaHorseRegistrationDto[]) {
      return [...registrations].sort((a, b) => {
        if (a.technicalSaleState === 'IMPRESSION' || a.technicalSaleState === 'CLOTUREE') {
          if (a.number !== null && b.number !== null) {
            return a.number - b.number
          }
        }
        return a.name.localeCompare(b.name)
      })
    },
    getAllDocumentsForSale(v: SaleWithRegistrationsDto & { expanded: boolean, expandedRegistrations: Page<FindByIdMyArqanaHorseRegistrationDto> }) {
      const res = [] as string[]

      v.expandedRegistrations.content.forEach(r => {
        const rules = documentsRule[r.type]
        if (rules) {
          Object.keys(rules).forEach(d => {
            if ((this.getMandatoryDocuments(r).includes(d) || this.getOptionalDocuments(r).includes(d)) && !res.includes(d)) {
              res.push(d)
            }
          })
        }
      })

      res.sort((a, b) => {
        if (a === 'DOSSIER_VETERINAIRE') { return 1 }
        if (b === 'DOSSIER_VETERINAIRE') { return -1 }

        const countMandatoryA = v.expandedRegistrations.content.filter(r => this.getMandatoryDocuments(r).includes(a)).length
        const countMandatoryB = v.expandedRegistrations.content.filter(r => this.getMandatoryDocuments(r).includes(b)).length

        if (countMandatoryA > countMandatoryB) { return -1 }
        if (countMandatoryA < countMandatoryB) { return 1 }

        const countOptionalA = v.expandedRegistrations.content.filter(r => this.getOptionalDocuments(r).includes(a)).length
        const countOptionalB = v.expandedRegistrations.content.filter(r => this.getOptionalDocuments(r).includes(b)).length

        if (countOptionalA > countOptionalB) { return -1 }
        if (countOptionalA < countOptionalB) { return 1 }

        return (this.$t(`documentType.${a}`) as string).localeCompare(this.$t(`documentType.${b}`) as string)
      })
      return res.filter(e => !e.startsWith('EXPORT_SANITARY_CERTIFICATE_') && e !== 'CHEVAL_ETRANGER')
    },
    isDocumentOpened(r: GetAllMyArqanaHorseRegistrationDto) {
      if (!['VISITED', 'COMPLETED'].includes(r.state)) {
        return false
      }
      const dateNow = formatISO(new Date(), { representation: 'date' })
      const startOpenDocumentUpload = formatISO(add(parseISO(r.technicalSale.startDate), { days: -30 }), { representation: 'date' })
      return dateNow < r.exposingDay && dateNow >= startOpenDocumentUpload
    },
    async openSignMandat(mandatTracking: MandatTracking) {
      try {
        this.queryUrl = true
        const signUrl = await saleApi.getSignUrl(mandatTracking.signTrackingId)
        window.open(signUrl, '_blank')
      } catch (err) {
        snackbarStore.setError(this.$t(handleAxiosException(err)) as string)
      } finally {
        this.queryUrl = false
      }
      this.openedMandatSale = 0
    },
    async massDownloadPedigrees(v: SaleWithRegistrationsDto & {expanded: boolean, expandedRegistrations: Page<FindByIdMyArqanaHorseRegistrationDto>}) {
      try {
        const pedigreeNumber = await myRegistrationApi.downloadAllPedigrees(v.expandedRegistrations.content.map(e => e.id))
        snackbarStore.setSuccess(`${this.$t('success.pedigree-mass-download')} ${pedigreeNumber} ${this.$t(pedigreeNumber > 1 ? 'success.pedigrees' : 'success.pedigree')}`)
      } catch (e) {
        snackbarStore.setSnackbar({ text: this.$t('error.loading') as string, color: 'error' })
      }
    },
    isVetCertificateOpen(v: MinimalTechnicalSaleWithSellerLetterDto) {
      const dateNow = formatISO(new Date(), { representation: 'date' })
      const vetCertificateOpening = formatISO(add(parseISO(v.startDate), { days: -7 }), { representation: 'date' })
      return dateNow <= v.startDate && dateNow >= vetCertificateOpening
    },
    openVetCertificateDialog(v: SaleWithRegistrationsDto) {
      this.vetCertificateDialog = true
      this.vetCertificateSale = v
      this.vetCertificateFile = undefined
      this.vetCertificateLoading = false
    },
    closeVetCertificateDialog() {
      this.vetCertificateDialog = false
      this.vetCertificateSale = undefined
      this.vetCertificateFile = undefined
      this.vetCertificateLoading = false
    },
    isMassDownloadOpen(v: SaleWithRegistrationsDto & {expanded: boolean, expandedRegistrations: Page<FindByIdMyArqanaHorseRegistrationDto>}) {
      return v.expandedRegistrations.content.some(registration => registration.pedigreeAvailable)
    },
    async sendVetCertificate() {
      if (this.vetCertificateFile && this.vetCertificateSale) {
        this.vetCertificateLoading = true
        try {
          await myRegistrationApi.sendVetCertificate(this.vetCertificateSale?.sale.id, this.vetCertificateFile)
          this.closeVetCertificateDialog()
          snackbarStore.setSnackbar({ text: this.$t('success.sending') as string, color: 'success' })
        } catch (e) {
          snackbarStore.setSnackbar({ text: this.$t('error.sending') as string, color: 'error' })
        }
        this.vetCertificateLoading = false
      }
    },
    async downloadSummary(v: SaleWithRegistrationsDto) {
      this.generatingSummarySale = v
      try {
        await myRegistrationApi.downloadSaleGroupSummary(v.sale.id, v.sale.name)
      } catch (e) {
        snackbarStore.setSnackbar({ text: this.$t('error.loading') as string, color: 'error' })
      }
      this.generatingSummarySale = undefined
    },
  },
  async mounted() {
    this.loadData()
  },
})
